import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

export function ScrollToError() {
    const formik = useFormikContext();
    const submitting = formik?.isSubmitting;

    useEffect(() => {
        if (!submitting) return;

        setTimeout(() => {
            const el = document.querySelector('.Mui-error, [data-error], .image-error');
            if (el) {
                (el.closest('.MuiFormControl-root') ?? el).scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100); // Додаємо невеликий таймаут, щоб форма встигла оновитися
    }, [submitting]);

    return null;
}